export const getLocationParams = (params: string) => {
  const locationParams = new URLSearchParams(params);

  // Prevent fetching branded fares from previously selected flight
  locationParams.delete("baseOfferToken");

  return locationParams;
};
